/********************************************************************************
Filename: np-carousel-slide.js
Created: 31 Oct 2022
Author: Ron Robertson
Description: A slide component to be used in the carousel
Usage Example:
<np-carousel>
    <np-carousel-slide></np-carousel-slide>
    <np-carousel-slide></np-carousel-slide>
    <np-carousel-slide></np-carousel-slide>
</np-carousel>
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
        #slide{

        }

        #slide .copy{
          position: absolute;
          left: 0px;
          right: 0px;
          margin-left: auto;
          margin-right: auto;
          width: calc((var(--col-width) * 6) + (var(--gutter-width) * 5));
          color: #ffffff;
          transform: translateX(0);
          animation-duration: 1.3s;
          animation-fill-mode: forwards;
          z-index: 200;
          bottom: 16px;
        }

        #slide .visual{
          overflow: hidden;
          height: 100%;
          aspect-ratio: 16/9;
          margin:0 auto;
          z-index: 100;
        }
        #slide .visual img{
          position: absolute;
          left: 50%;
          object-fit: cover;
          height: 100%;
          width: 100%;
          max-width: 1200px;
          transform: translateX(-50%);

        }
        #slide .visual::after{
          content:"";
          position:absolute;
          bottom: 0px;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          max-width: 1200px;
          height: 100%;
          background: linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 50%);
        }

        #slide .copy .carouselCategory{
          display:inline-block;
          font-family: var(--h4FontFamily);
          font-weight:normal;
          color:#41B6E6;
          padding-right:6px;
          font-size: 14px;
        }

        #slide .copy .carouselDate{
          display:inline-block;
          display: none; // hiding date in carousel
          font-weight:normal;
          padding-left:8px;
          border-left:1px solid #ffffff;
          font-size: 14px;
        }
        #slide .copy .carouselTitle{
          margin:10px 0 0;
          font-size: 24px;
          font-family: var(--h2FontFamily);
          font-weight:normal;
        }
        #slide .copy .carouselTitle:hover{
          cursor: pointer;
        }

        /*** Animation ***/
        :host(.cycleOutLeft) .copy{
          animation-name: contentSlideOutLeft;
        }
        :host(.cycleOutRight) .copy{
          animation-name: contentSlideOutRight;
        }
        :host(.cycleInLeft) .copy{
          animation-name: contentSlideInLeft;
        }
        :host(.cycleInRight) .copy{
          animation-name: contentSlideInRight;
        }

        /*** Media Queries ***/
        @keyframes slideOutLeft {
            0% {transform: translateX(0px);}
            70% {transform: translateX(-100%);}
            100% {transform: translateX(-100%);}
        }
        @keyframes slideOutRight {
            0% {transform: translateX(0px);}
            70% {transform: translateX(100%);}
            100% {transform: translateX(100%);}
        }
        @keyframes slideInLeft {
            0% {transform: translateX(0px);}
            70% {transform: translateX(-100%);}
            100% {transform: translateX(-100%);}
        }
        @keyframes slideInRight {
            0% {transform: translateX(0px);}
            70% {transform: translateX(100%);}
            100% {transform: translateX(100%);}
        }
        @keyframes contentSlideInLeft {
          0% {transform: translateX(20%);}
          100% {transform: translateX(0%);}
        }
        @keyframes contentSlideInRight {
            0% {transform: translateX(-20%);}
            100% {transform: translateX(0%);}
        }
        @keyframes contentSlideOutLeft {
            0% {transform: translateX(0%);}
            100% {transform: translateX(40px);}
        }
        @keyframes contentSlideOutRight {
            0% {transform: translateX(0%);}
            100% {transform: translateX(-40px);}
        }

      @media screen and (min-width: 480px) {
        #slide .copy{
          bottom: 40px;
        }
      }
      @media screen and (min-width: 768px) {
        #slide .copy{
            width: calc((var(--col-width) * 12) + (var(--gutter-width) * 11));
        }
        #carouselTitle{
            margin:24px 0 0;
        }
      }
      @media screen and (min-width: 1200px) {
          #slide .copy{
              width: calc((var(--col-width) * 10) + (var(--gutter-width) * 11));
              max-width: 995px;
          }
      }

        </style>

        <div id="slide">
            <div class="visual">
                <img>
            </div><!--END visual-->
            <div class="copy">
                <div class="carouselCategory"></div>
                <div class="carouselDate"></div>
                <div class="carouselTitle"></div>
            </div><!--END copy-->
        </div><!--END slide-->
    `;

    class NpCarouselSlide extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            /* bind 'this' to class in the method */
            /* this.myMethod = this.myMethod.bind(this); */

            /* Use the Shadow DOM */
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            /* Reference to DOM Elements */
            this.slide = this.shadowRoot.getElementById("slide");
            this.imgEle = this.shadowRoot.querySelector(".visual img");
            this.categoryEle = this.shadowRoot.querySelector(".copy .carouselCategory");
            this.dateEle = this.shadowRoot.querySelector(".copy .carouselDate");
            this.titleEle = this.shadowRoot.querySelector(".copy .carouselTitle");

        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {

            /* Set default attribute value */
            /*
            if (!this.hasAttribute('myattribute')) {
                this.setAttribute('myattribute', "value");
            }
            */

            /* Set Event Listeners */
            this.titleEle.addEventListener('click', this.onRouterLinkClick);

        } /* END connectedCallback */

        /* Listen for when attributes change */
        /* attributes must be lowercase */
        static get observedAttributes() {
            return ['title', 'img', 'category', 'date', 'link-url'];
        }

      /* Called when attributes change */
      attributeChangedCallback(name, oldValue, newValue) {

        if(name === 'title') {
            this.titleEle.innerHTML = newValue;
        }
        if(name === 'img') {
            this.imgEle.setAttribute('src', newValue);
        }
        if(name === 'category') {
            this.categoryEle.innerHTML = newValue;
        }
        if(name === 'date') {
            this.dateEle.innerHTML = newValue;
        }
        if(name === 'link-url') {
          this.titleEle.setAttribute('router-link',newValue);
      }

       }/* END attributesChangedCallback */

      /* Getting attributes */
      get title() {
        return this.getAttribute('title');
      }
      get img() {
        return this.getAttribute('img');
      }
      get category() {
        return this.getAttribute('category');
      }
      get date() {
        return this.getAttribute('date');
      }
      get linkUrl() {
        return this.getAttribute('link-url');
      }


      /* Settinng attributes */
      set title(newValue) {
        this.setAttribute('title', newValue);
      }
      set img(newValue) {
        this.setAttribute('img', newValue);
      }
      set category(newValue) {
        this.setAttribute('category', newValue);
      }
      set date(newValue) {
        this.setAttribute('date', newValue);
      }
      set linkUrl(newValue) {
        this.setAttribute('link-url', newValue);
      }


      /* Called when removed from DOM */
      disconnectedCallback() {

        /* Removing event listeners */
        this.titleEle.removeEventListener('click', this.onRouterLinkClick);
      }

        /* Method */
      //dispatches the event so other components can listen for it
      onRouterLinkClick(event) {
        event.preventDefault();
        // Dispatch the event
        this.dispatchEvent(new CustomEvent('routerLinkClick',{bubbles:true,composed:true,detail:{'url':event.target.getAttribute('router-link')}}));
      }

    } /* END class */

    window.customElements.define('np-carousel-slide', NpCarouselSlide);

  })();
